import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { PRODGY_CHART_COLORS } from '@/shared/constants/colors';
import { useChartTheme } from './chartTheme';

interface AreaChartProps {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  config: {
    xAxis?: string;
    yAxis?: string;
    groupBy?: string;
  };
}

export const AreaChart = ({ data, config }: AreaChartProps) => {
  const chart = useChartTheme();

  const option: EChartsOption = {
    color: PRODGY_CHART_COLORS,
    backgroundColor: chart.background,
    textStyle: { color: chart.axisLabel },
    tooltip: {
      trigger: 'axis',
      backgroundColor: chart.tooltipBg,
      borderColor: chart.tooltipBorder,
      textStyle: {
        color: chart.tooltipText,
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '10%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.labels || (config.xAxis ? data[config.xAxis] : undefined) || [],
      axisLine: {
        lineStyle: {
          color: chart.axisLine,
        },
      },
      axisLabel: {
        color: chart.axisLabel,
      },
    },
    yAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: chart.axisLine,
        },
      },
      axisLabel: {
        color: chart.axisLabel,
      },
      splitLine: {
        lineStyle: {
          color: chart.splitLine,
        },
      },
    },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    series: data.series?.map((s: any) => ({
      name: s.name,
      data: s.data,
      type: 'line',
      areaStyle: {
        opacity: 0.3,
      },
      smooth: true,
      lineStyle: {
        width: 2,
      },
      stack: 'total',
    })) || [
      {
        data: data.values || (config.yAxis ? data[config.yAxis] : undefined) || [],
        type: 'line',
        areaStyle: {
          opacity: 0.3,
        },
        smooth: true,
        lineStyle: {
          width: 2,
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: '100%', width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};
